import React, { useState, useEffect } from 'react'
import "../css/ResetPasswordSA.css"
import { useSelector } from "react-redux"
import { selectEmployees } from 'src/stores/employeeSlice';
import { notify } from '../utils/ToastUtils';
import ApiClient from '../ApiClient';
import IndiaUpdateUser from 'src/components/IndiaUpdateUser';
import UsUpdateUser from 'src/components/UsUpdateUser';
import { User, Search, UserSearch } from 'lucide-react';
import { TextField, InputAdornment, MenuItem, Autocomplete } from '@mui/material';

function UpdateUser() {
	const initialState = {
		empCode: "",
		empID: ""
	}
	const [state, setState] = useState(initialState)
	const [isDisabled, setIsDisabled] = useState(false)
	const employees = useSelector(selectEmployees)
	const [empCountry, setEmpCountry] = useState("");
	const [empInfo, setEmpInfo] = useState({});
	
	function handleChange(evt) {
		const value = evt.target.value;
		setState({
			...state,
			[evt.target.name]: value
		});
	}

	const getEmpProfile = async () => {
		if (state.empCode) {
			try {
				setIsDisabled(true);
				const { data } = await ApiClient.post(`${process.env.REACT_APP_BASE_URL}/user/getEmpProfile`, {
					empcode: state.empCode
				})
				setEmpInfo(data[0])
				setEmpCountry(data[0].EMP_COUNTRY);
			} catch (err) {
				console.log(err)
			} finally {
				setIsDisabled(false);
			}
		} else notify.error("Please select the employee name")
	}

	return (
		<div className="space-y-4 flex-1 flex flex-col">
			<div className="bg-white border border-slate-200 rounded-2xl p-6 shadow-sm">
				<div className="flex items-center gap-2 mb-4">
					<div className="p-1.5 bg-blue-50 text-blue-600 rounded-lg">
						<UserSearch size={18} />
					</div>
					<h3 className="font-bold text-slate-800 text-base">Select Employee</h3>
				</div>
				<div className="flex flex-col md:flex-row items-end gap-3">
					<div className="flex-1 w-full">
						<label className="block text-sm font-semibold text-slate-700 mb-1.5">Employee Name</label>
						<Autocomplete
							options={employees || []}
							getOptionLabel={(option) => `${option.EMP_NAME} - ${option.EMP_ID}`}
							value={employees?.find(el => el.EMP_CODE === state.empCode) || null}
							onChange={(event, newValue) => {
								handleChange({ target: { name: 'empCode', value: newValue ? newValue.EMP_CODE : '' } });
							}}
							size="small"
							className="w-full bg-white"
							sx={{ '& .MuiOutlinedInput-root': { padding: '2px 8px', minHeight: '40px', borderRadius: '8px' }, '& .MuiAutocomplete-input': { padding: '4px !important', fontSize: '14px' } }}
							ListboxProps={{ style: { maxHeight: 250, fontSize: '14px' } }}
							renderInput={(params) => (
								<TextField 
									{...params}
									required
									placeholder="Search employee by name"
									InputProps={{ 
										...params.InputProps,
										startAdornment: (
											<>
												<InputAdornment position="start" sx={{ ml: 1 }}>
													<Search size={16} className="text-slate-400"/>
												</InputAdornment>
												{params.InputProps.startAdornment}
											</>
										)
									}} 
								/>
							)}
						/>
					</div>
					<button type="button" className={`px-5 py-2 h-[40px] bg-blue-600 text-white rounded-lg transition-colors font-medium text-sm flex items-center justify-center gap-2 shadow-sm whitespace-nowrap ${isDisabled ? 'opacity-70 cursor-not-allowed' : 'hover:bg-blue-700'}`} onClick={getEmpProfile} disabled={isDisabled}>
						{isDisabled ? (
							<span className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
						) : (
							<UserSearch size={16} />
						)}
						Load Profile
					</button>
				</div>
			</div>
			{empCountry=="" ?<div></div> : empCountry=="India"? <IndiaUpdateUser data={empInfo} /> : <UsUpdateUser data={empInfo} />}
		</div>
	)
}

export default UpdateUser